import { TranslationKeys } from './constants';
export const validateLogoUrl = (url, t) => {
    if (!url || url.trim() === '') {
        return '';
    }
    if (!url.startsWith('https://')) {
        return t(TranslationKeys.VALIDATION_LOGO_URL_HTTPS);
    }
    try {
        const validatedUrl = new URL(url);
        if (validatedUrl) {
            return '';
        }
        return t(TranslationKeys.VALIDATION_INVALID_URL);
    }
    catch (error) {
        return t(TranslationKeys.VALIDATION_INVALID_URL);
    }
};
export const validatePhoneNumber = (phone, t) => {
    if (!phone || phone.trim() === '') {
        return '';
    }
    const cleanedPhone = phone.replace(/[\s\-()+ .]/g, '');
    if (!/^\d+$/.test(cleanedPhone)) {
        return t(TranslationKeys.VALIDATION_PHONE_INVALID_CHARACTERS);
    }
    if (cleanedPhone.length < 10 || cleanedPhone.length > 15) {
        return t(TranslationKeys.VALIDATION_PHONE_LENGTH);
    }
    return '';
};
const URL_REGEX = /^https?:\/\/([A-Za-z0-9-]+\.)+[A-Za-z]{2,}(:[0-9]{1,5})?(\/[A-Za-z0-9\-._~:/?#[\]@!$&'()*+,;=%]*)?$/;
export const validateUrl = (url, t) => {
    if (!url || url.trim() === '') {
        return '';
    }
    const trimmedUrl = url.trim();
    if (!trimmedUrl.startsWith('http://') &&
        !trimmedUrl.startsWith('https://')) {
        return t(TranslationKeys.VALIDATION_URL_HTTP_HTTPS);
    }
    if (!URL_REGEX.test(trimmedUrl)) {
        return t(TranslationKeys.VALIDATION_INVALID_URL);
    }
    try {
        const validatedUrl = new URL(trimmedUrl);
        if (validatedUrl.protocol !== 'http:' &&
            validatedUrl.protocol !== 'https:') {
            return t(TranslationKeys.VALIDATION_URL_HTTP_HTTPS);
        }
        return '';
    }
    catch (error) {
        return t(TranslationKeys.VALIDATION_INVALID_URL);
    }
};
export const getLogoSizeClass = (logoSize, styles) => {
    switch (logoSize) {
        case 'Small':
            return styles.logoSmall;
        case 'Large':
            return styles.logoLarge;
        default:
            return styles.logoMedium;
    }
};
//# sourceMappingURL=email-customization-utils.js.map